import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/');

export default function FeaturedIn() {
    const { useLang, Link, isMobile } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');

    const featureLists_pc = [
        {
            h: '50px',
            w: '256px',
            avatar: 'delta2_CNN',
            link: 'https://edition.cnn.com/cnn-underscored/reviews/best-solar-generators',
        },
        {
            h: '50px',
            w: '65px',
            avatar: 'delta2_MUO',
            link: 'https://www.makeuseof.com/ifa-2022-muo-awards/',
        },
        {
            h: '50px',
            w: '287px',
            avatar: 'delta2_DigitalTrends',
            link: 'https://www.digitaltrends.com/dtdeals/ecoflow-delta-2/',
        },
        {
            h: '50px',
            w: '279px',
            avatar: 'delta2_Frandroid',
            link: 'https://www.frandroid.com/events/ifa/1455370_nos-huit-meilleures-nouveautes-a-retenir-de-lifa-2022',
        },
        {
            h: '50px',
            w: '67px',
            avatar: 'delta2_BBC',
            link: 'https://www.bbc.co.uk/iplayer/episode/m001cm25/click-best-in-tech-show',
        },
        {
            h: '50px',
            w: '250px',
            avatar: 'delta2_InsideDigital',
            link: 'https://www.inside-digital.de/news/ecoflow-delta-2-neue-powerstation-fuer-dein-balkonkraftwerk',
        },
        {
            h: '50px',
            w: '45px',
            avatar: 'delta2_Bild',
            link: 'https://www.bild.de/video/clip/video/ecoflow-manager-zeigt-so-machen-sie-auch-ohne-solar-dach-ihren-eigenen-strom-81227458.bild.html',
        },
        {
            h: '50px',
            w: '319px',
            avatar: 'delta2_EFahrer',
            link: 'https://efahrer.chip.de/news/mega-generator-im-test-er-hat-genug-power-fuer-ein-ganzes-haus_107520',
        },
        {
            h: '50px',
            w: '103px',
            avatar: 'delta2_Times',
            link: 'https://www.thetimes.co.uk/article/20-things-to-buy-to-beat-the-blackouts-this-winter-gksvvwj3n ',
        },
    ];

    const featureLists_h5 = [
        {
            avatar: 'delta2_CNN',
            w: '1.18rem',
            h: '.23rem',
            link: 'https://edition.cnn.com/cnn-underscored/reviews/best-solar-generators',
        },
        {
            avatar: 'delta2_MUO',
            w: '.39rem',
            h: '.3rem',
            link: 'https://www.makeuseof.com/ifa-2022-muo-awards/',
        },
        {
            avatar: 'delta2_DigitalTrends',
            w: '1.32rem',
            h: '.23rem',
            link: 'https://www.digitaltrends.com/dtdeals/ecoflow-delta-2/',
        },
        {
            avatar: 'delta2_Frandroid',
            w: '1.29rem',
            h: '.23rem',
            link: 'https://www.frandroid.com/events/ifa/1455370_nos-huit-meilleures-nouveautes-a-retenir-de-lifa-2022',
        },
        {
            avatar: 'delta2_BBC',
            w: '.4rem',
            h: '.3rem',
            link: 'https://www.bbc.co.uk/iplayer/episode/m001cm25/click-best-in-tech-show',
        },
        {
            avatar: 'delta2_InsideDigital',
            w: '1.15rem',
            h: '.23rem',
            link: 'https://www.inside-digital.de/news/ecoflow-delta-2-neue-powerstation-fuer-dein-balkonkraftwerk',
        },
        {
            avatar: 'delta2_Bild',
            w: '.3rem',
            h: '.27rem',
            link: 'https://www.bild.de/video/clip/video/ecoflow-manager-zeigt-so-machen-sie-auch-ohne-solar-dach-ihren-eigenen-strom-81227458.bild.html',
        },
        {
            avatar: 'delta2_Times',
            w: '.63rem',
            h: '.3rem',
            link: 'https://www.thetimes.co.uk/article/20-things-to-buy-to-beat-the-blackouts-this-winter-gksvvwj3n ',
        },
        {
            avatar: 'delta2_EFahrer',
            w: '1.66rem',
            h: '.26rem',
            link: 'https://efahrer.chip.de/news/mega-generator-im-test-er-hat-genug-power-fuer-ein-ganzes-haus_107520',
        },
    ];

    const featureLists = isMobile ? featureLists_h5 : featureLists_pc;

    return (
        <div
            className={`${css.featureIn} featureIn ${isMobile ? 'feature_h5' : 'feature_pc'}  GtmModuleData-section`}
            data-section-id={css.featureIn}
            data-section-title={t('delta2.feature_title')}
        >
            <div className="title">{t('delta2.feature_title')}</div>
            <div className="featureBox">
                {featureLists?.map((item, i) => (
                    <div className={`item ${isMobile ? '' : i <= 3 ? 'top' : 'bot'}`} key={i}>
                        <Link href={item?.link}>
                            <div className="img" style={{ width: item?.w, height: item?.h }}>
                                <EFPic name={[`${item.avatar}.webp`, `${item.avatar}.png`]} />
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}
